import { renderOptionFields } from "./optionFieldsView.js";

export function renderOptionsView(state, displayContext = {}) {
  const { options } = state.metaState;

  return `
    <div class="screen screen--options" data-screen-id="options">
      <section class="panel panel--medium">
        <div class="panel-header">
          <div>
            <p class="eyebrow">Options</p>
            <h2>Command Interface</h2>
          </div>
          <button class="ghost-button" data-action="back-to-title">Back</button>
        </div>
        <div class="options-list">
          ${renderOptionFields(options, { ...displayContext, showDisplayOptions: true })}
        </div>
      </section>
    </div>
  `;
}
